<template>
  <div class="mb-container">
    <mb-header title="等待考试" :back="goBack"/>
    <div class="mb-time-wrap">
      <div class="mb-tips">
        <p>为避免影响正常考试</p>
        <p>请考生提前进行设备检测</p>
      </div>
      <countdown
        class="mb-timeCount"
        v-show="testInfo.start_time"
        :remoteTime="testInfo.start_time"
        @listen="listen"
      ></countdown>
    </div>
    <div class="mb-info-wrap">
      <div class="mb-info">
        <div class="mb-exam-box">
          <div class="mb-row">
            <span class="mb-label">考试名称：</span>
            <span class="mb-text">{{testInfo.exam_name}}</span>
          </div>
          <div class="mb-row">
            <span class="mb-label">开考时间：</span>
            <span class="mb-text">{{testInfo.start_time | date}}</span>
          </div>
          <div class="mb-row">
            <span class="mb-label">结束时间：</span>
            <span class="mb-text">{{testInfo.end_time | date}}</span>
          </div>
          <div class="mb-row">
            <span class="mb-label">答题时间：</span>
            <span class="mb-text">{{testInfo.exam_time && `${testInfo.exam_time}分钟`}}</span>
          </div>
        </div>
        <div class="mb-user-box">
          <div class="mb-row">
            <span class="mb-label">考生姓名：</span>
            <span class="mb-text">{{testInfo.name}}</span>
          </div>
          <div class="mb-row">
            <span class="mb-label">身份证号：</span>
            <span class="mb-text">{{testInfo.identity_num}}</span>
          </div>
          <div class="mb-row">
            <span class="mb-label">手机号码：</span>
            <span class="mb-text">{{testInfo.mobile}}</span>
          </div>
          <div class="mb-row">
            <span class="mb-label">所在地区：</span>
            <span class="mb-text">{{testInfo.area}}</span>
          </div>
          <div class="mb-row">
            <span class="mb-label">所在学校：</span>
            <span class="mb-text">{{testInfo.school}}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="mb-footer">
      <button class="mb-button mb-mr-12" @click="goDetectPage">设备检测</button>
      <button
        :disabled="startTestBtnDisabled"
        :class="{
          'mb-button': true,
          'mb-primaray': true,
          'mb-disabled': startTestBtnDisabled
        }"
        @click="startTest"
      >开始考试</button>
    </div>
    <MbModal
      title="提示"
      :show.sync="isShowModal"
    >
      <p slot="content">{{modalTips}}</p>
      <div slot="footer" class="mb-modal-footer">
        <button
          v-show="isFirstDetect"
          class="mb-button mb-primaray"
          @click="goDetectPage"
        >开始检测</button>
        <button
          v-show="!isFirstDetect"
          class="mb-button mb-width-252 mb-mr-12"
          @click="goTestPage"
        >继续考试</button>
        <button
          v-show="!isFirstDetect"
          class="mb-button mb-primaray mb-width-252"
          @click="isShowModal = false"
        >取消</button>
      </div>
    </MbModal>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import moment from 'moment'
import { get, post } from '@/utils/ajax'
import MbHeader from '@/components/MbHeader'
import MbModal from '@/components/MbModal'
import Countdown from './countdownForH5'
import {
  CLOSE_WEBVIEW,
  postMessageSyn
} from '@/utils/dsbridge'

export default {
  components: {
    MbHeader,
    MbModal,
    Countdown
  },
  computed: {
    ...mapState(['theme', 'weishengRoute', 'testConfig']),
    testInfo() {
      return this.$store.state.testInfo
    },
    getTimeText() {
      return (start, end) => {
        return start && `${moment(start).format('YYYY-MM-DD HH:mm')} - ${moment(end).format('HH:mm')}`
      }
    },
    startTestBtnDisabled() {
      // 先判断考试状态  再学生状态 再时间
      // 考生考试状态(0:未开始, 1:考试中且未答题, 2:考试中且已答题, 3:考试中且已答所有题, 4:已交卷, 5:考试结束, 6: 缺考, 7:批改中，8：已批改, 9:强制终止, 10: 已被换考)
      return this.hasNoTest || ([4, 5, 6, 7, 8, 9, 10].includes(this.testInfo.examinee_status)) || this.showTime || this.btnLoading
    },
    modalTips () {
      return this.isFirstDetect ? '为保证考试正常进行，请先进行设备检测' : '你的设备检测未通过，若因设备检测未通过而影响到正常考试，由考生自行承担后果，是否进入考试？'
    }
  },
  watch: {
    testInfo (n) {
      if (!n.start) { // 该站点没有考试
        this.hasNoTest = true
        return
      }
      if (n.exam_status === 0) {
        this.$message.warning('考试卷正在配置中')
      }
      if ([3, 4].includes(n.exam_status)) {
        this.$message.warning('考试已终止或已结束')
      }
      this.hasNoTest = n.exam_status !== 2 // exam_status：0-草稿 1-未开始 2-进行中 3-已结束 4-已中止
    }
  },
  data() {
    return {
      showTime: true,
      hasNoTest: false,
      time: 0,
      needIdentity: false,
      btnLoading: false,
      isShowModal: false,
      isFirstDetect: false
    }
  },
  async mounted () {
    this.checkDetect()
    if (this.$store.state.hasToken) {
      if (this.$route.query.examId) { // 外链带examId过来
        localStorage.examId = this.$route.query.examId
      }
      if (localStorage.examId) { // 从列表进入
        await this.$store.dispatch('getTestInfo', false)
        await this.$store.dispatch('getTestConfig')
      } else { // 本地无examId
        this.$router.push({ name: 'list' })
        return
      }
    }
    this.hasNoTest = !this.testInfo.start
    const checkDetect = await this.checkDetect() // null true false
    this.isFirstDetect = checkDetect === null
    this.needIdentity = this.isFirstDetect || checkDetect
    this.$store.dispatch('setMonitorReport', { type: 3 }) // 上报考试监控埋点，进入候考
  },
  methods: {
    listen (showTime) {
      // console.log('showTime', showTime)
      this.showTime = showTime
    },
    async startTest () {
      if (this.startTestBtnDisabled) return
      this.goTestPage()
    },
    goDetectPage() {
      this.$router.push({ name: 'detect' })
    },
    async goTestPage() {
      try {
        this.btnLoading = true
        await post(`/home/edu/examinees/start/${this.testInfo.exam_id}/${this.testInfo.examinee_id}`)
        localStorage.setItem('user_id', this.$store.state.user.id)
        this.$router.push({ name: 'test' })
        this.btnLoading = false
      } catch (e) {
      }
    },
    async checkDetect() { // 判断该设备是否需要设备检测
      const finger = this.$store.state.browserFinger
      const deviceTypes = [1, 2, 3]
      const { deviceCheckInfo } = await get(`/home/devices/check/info?serialNumber=${finger}`)

      if (Array.isArray(deviceCheckInfo) && !deviceCheckInfo.length) {
        return null
      }

      let needDetect = false
      for (const { deviceType, deviceStatus } of deviceCheckInfo) {
        if (deviceTypes.includes(deviceType) && !deviceStatus) {
          needDetect = true
          break
        }
      }
      return needDetect
    },
    goBack() {
      postMessageSyn(CLOSE_WEBVIEW)
    }
  }
}
</script>
<style lang="scss" scoped>
.mb-container {
  padding-bottom: 140px;
  .mb-time-wrap {
    height: 413px;
    width: 100%;
    background: url('~@/assets/images/exam/timeWrapBg.png') no-repeat;
    background-size: 100% 413px;
    .mb-tips {
      padding-top: 82px;
      p {
        display: flex;
        justify-content: center;
        color: #333;
        font-size: 32px;
        font-weight: 500;
        line-height: 45px;
      }
    }
  }
  .mb-info-wrap {
    padding: 62px 64px 0;
    .mb-exam-box, .mb-user-box {
      background: #F9F9F9;
      border-radius: 4px;
      padding: 26px 24px;
      margin-bottom: 33px;
      .mb-row {
        font-size: 28px;
        line-height: 40px;
        &:not(:last-child) {
          margin-bottom: 12px;
        }
        .mb-label {
          color: #999;
        }
        .mb-text {
          color: #333;
        }
      }
    }
  }
  .mb-footer {
    width: 100vw;
    height: 140px;
    display: flex;
    flex-direction: row;
    justify-content: center;
    padding: 30px 60px;
    position: fixed;
    left: 0;
    bottom: 0;
    box-shadow: 0px -1px 4px 0px rgba(0, 0, 0, 0.06);
    background-color: #fff;
  }
  .mb-button {
    width: 300px;
    height: 80px;
    text-align: center;
    line-height: 80px;
    border-radius: 2px;
    border: 1px solid #3D81FF;
    font-size: 32px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #3D81FF;
    background: #fff;
  }
  .mb-mr-12 {
    margin-right: 24px;
  }
  .mb-primaray {
    background: #3D81FF;
    box-shadow: 0px 6px 10px 0px rgba(63, 131, 255, 0.35);
    color: #fff;
  }
  .mb-disabled {
    color: #fff;
    background: #C9C9C9;
    border: none;
    box-shadow: none;
  }
  .mb-timeCount {
    margin-top: 32px;
  }
  .mb-modal-footer {
    display: flex;
    justify-content: center;
    padding: 46px 0;
  }
  .mb-mr-12 {
    margin-right: 24px;
  }
  .mb-width-252 {
    width: 252px;
  }
}
</style>
